import React, { useEffect, useState } from "react";
import Filterswhishlist from "./filterswhishlist";
import { GoPeople } from "react-icons/go";
import Bycall from "../../pages/expert/Modals/bycall";
import Bychat from "../../pages/expert/Modals/bychat";
import Bycredit from "../../pages/expert/Modals/bycredit";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../LoadingSpinner/loadingSpinner";
import Buycredit from "../../pages/expert/Modals/buycredit";
import Cookies from "js-cookie";
import api from "../../api";
import { Tooltip } from "react-tooltip";

const FavoriteContent = ({
  cards,
  user,
  max,
  total,
  userCredits,
  inboundStatuses,
}) => {
  const [cardsData, setCardsData] = useState(cards);
  const [filteredCards, setFilteredCards] = useState(cards);
  const [searchTerm, setSearchTerm] = useState("");
  const [languageData, setLanguageData] = useState(null);
  const [timeElapsed, setTimeElapsed] = useState(1);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showBuyCreditModal, setShowBuyCreditModal] = useState(false);
  const [credits, setCredits] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showModalChat, setShowModalChat] = useState(false);
  const [showModalCredit, setShowModalCredit] = useState(false);
  const [timers, setTimers] = useState({});
  const [totalCredits, setTotalCredits] = useState(0);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/experts/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }

    const interval = setInterval(() => {
      setTimeElapsed((prevTime) => {
        if (prevTime < 7200) {
          return prevTime + 1;
        }
        clearInterval(interval);
        return prevTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [cards]);

  useEffect(() => {
    setCardsData(cards);
    setFilteredCards(cards);
  }, [cards]);

  if (!languageData) {
    return;
  }

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}:${String(seconds).padStart(2, "0")}`;
  };
  const handleRemoveClick = async (expertId) => {
    const result = await Swal.fire({
      title: languageData?.alert?.add_favorite?.title,
      text: languageData?.alert?.add_favorite?.description,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: languageData?.alert?.add_favorite?.remove?.title,
      cancelButtonText: languageData?.alert?.add_favorite?.remove?.button,
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);
      const response = await api.post(`/content/wishlist/remove`, {
        expert_id: expertId,
      });
      /* setFilteredCards((prevCards) =>
        prevCards.filter((card) => Number(card.id) !== Number(expertId)),
      ); */
      setCardsData((prev) =>
        prev.filter((card) => Number(card.id) !== Number(expertId)),
      );

      setFilteredCards((prev) =>
        prev.filter((card) => Number(card.id) !== Number(expertId)),
      );

      Swal.fire(
        languageData?.alert?.add_favorite?.remove?.title,
        languageData?.alert?.add_favorite?.remove?.description,
        "success",
      );
    } catch (error) {
      console.error(error);
      Swal.fire(
        languageData?.alert?.add_favorite?.error?.title,
        languageData?.alert?.add_favorite?.error?.text,
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filters = []) => {
    //  let result = [...cards];
    let result = [...cardsData];
    if (filters.includes("available")) {
      result = result.filter((card) => card.status === "available");
    }

    if (filters.includes("favorite")) {
      result = result.filter((card) => card.favorite === true);
    }

    if (searchTerm) {
      result = result.filter((card) =>
        card.nickname
          .toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()),
      );
    }

    setFilteredCards(result);
  };

  const handleSortChange = (sortOption) => {
    let sortedCards = [...filteredCards];

    switch (sortOption) {
      case "newest":
        sortedCards.sort(
          (a, b) => new Date(b.creation_date) - new Date(a.creation_date),
        );
        break;
      case "rating":
        sortedCards.sort((a, b) => (b.rating || 0) - (a.rating || 0));
        break;
      case "reading":
        sortedCards.sort((a, b) => (b.readings || 0) - (a.readings || 0));
        break;
      case "availability":
        sortedCards.sort((a, b) => {
          const getStatusPriority = (status) => {
            if (status === "available") return 1;
            if (status.includes("in_call")) return 2;
            if (status === "not_available") return 3;
            return 4;
          };
          const priorityA = getStatusPriority(a.status);
          const priorityB = getStatusPriority(b.status);
          return priorityA - priorityB;
        });
        break;
      case "featured":
      default:
        sortedCards = [...cardsData];
    }

    setFilteredCards(sortedCards);
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value || "");

    const filteredBySearch = cardsData.filter(
      (card) =>
        card.code.toString().toLowerCase().includes(value.toLowerCase()) ||
        card.nickname.toString().toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredCards(filteredBySearch);
  };

  const getStatusStyle = (status) => {
    if (status === languageData.card.status.available) {
      return "bg-success";
    } else if (status === languageData.card.status.not_available) {
      return "bg-dark bg-opacity-50";
    } else if (status.includes(languageData.card.status.in_call)) {
      return "bg-warning";
    }
    return "";
  };

  const getDisplayStatus = (card) => {
    if (card.status === "in_call") {
      return `${languageData.card.status.in_call} ~ ${formatTime(timeElapsed)}`;
    }

    if (card.status === "available") {
      return languageData.card.status.available;
    } else if (card.status === "not_available") {
      return languageData.card.status.not_available;
    }
    return card.status;
  };

  const handleOpenModal = (expert) => {
    setSelectedExpert(expert);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedExpert(null);
  };

  const handleOpenModalChat = (expert) => {
    setSelectedExpert(expert);
    setShowModalChat(true);
  };

  const handleCloseModalChat = () => {
    setShowModalChat(false);
    setSelectedExpert(null);
  };

  const handleOpenModalCredit = async (expert) => {
    setSelectedExpert(expert);
    setLoading(true);
    try {
      const res = await api.get(`/content/load`, {
        params: {
          "types[]": "credits",
        },
      });

      const creditsData = res.data?.data?.credits || [];

      setCredits(creditsData);
      const total = creditsData.reduce(
        (total, item) => total + Number(item.credit || 0),
        0,
      );
      setTotalCredits(total);
      if (total > 0) {
        setShowBuyCreditModal(false);
        setShowModalCredit(true);
      } else {
        setShowModalCredit(false);
        setShowBuyCreditModal(true);
      }
    } catch (error) {
      console.error("Error loading credits:", error);
      setShowBuyCreditModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModalCredit = () => {
    setShowModalCredit(false);
    setSelectedExpert(null);
  };

  const getInboundStatus = (card) => {
    const extension = card.services
      ?.flatMap((s) => s.extensions || [])
      ?.find((e) => e.type === "inbound")?.data;

    return extension ? inboundStatuses?.[extension]?.label : null;
  };
  const APP_SERVICES = process.env.REACT_APP_APP_SERVICES;
  const SERVICES = APP_SERVICES.split(",").map((s) => s.trim());
  const hasService = (key) => SERVICES.includes(key);
  return (
    <>
      <Filterswhishlist
        onFilterChange={handleFilterChange}
        onSortChange={handleSortChange}
        onSearchChange={handleSearchChange}
      />

      <div className="mb-3 text-start">
        <div className="fs-15 mb-sm-0 mb-2">
          <span className="badge bg-success me-2">
            {/*  {cards.filter((card) => card.favorite === true).length}  */}
            {total || 0}
          </span>
          {languageData.whislist.result}
        </div>
      </div>
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 pe-0">
        <div className="row">
          {filteredCards.length === 0 ? (
            <div
              className="no-results d-flex flex-column justify-content-center align-items-center text-center"
              style={{ minHeight: "200px", marginTop: "150px" }}
            >
              <GoPeople style={{ fontSize: "40px", color: "grey" }} />
              <div>
                <h3 className="text-muted">{languageData.no_wish}</h3>
                <p className="text-muted">{languageData.find2}</p>
              </div>
            </div>
          ) : (
            filteredCards.map((card) => (
              <div
                key={card.id}
                className="col-xxl-4 col-xl-6 col-lg-12 col-md-12 col-sm-12 pe-0"
              >
                <div className="card custom-card product-card">
                  <div className="card-header d-block py-2 px-3">
                    <div
                      className="d-sm-flex d-block justify-content-between"
                      ref={(el) => {
                        if (el)
                          el.style.setProperty("display", "flex", "important");
                      }}
                    >
                      <div>
                        <span className="fs-12 fw-semibold ">
                          {languageData.card.code}:
                        </span>
                        <span className="text-primary ml-10p">
                          {
                            card.services.find(
                              (service) => service.call_type === "prn",
                            )?.code
                          }{" "}
                        </span>
                      </div>

                      <div className="product-icons">
                        <a
                          data-interaction="remove_favorite_button"
                          aria-label=""
                          href="#"
                          className="wishlist remove_btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleRemoveClick(card.id);
                          }}
                        >
                          <span>{languageData.card.remove}</span>
                          <i className="ri-close-line"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="card-body py-2 px-3">
                    <div
                      className="d-sm-flex align-items-start text-start"
                      ref={(el) => {
                        if (el)
                          el.style.setProperty("display", "flex", "important");
                      }}
                    >
                      <a
                        data-interaction="expert_image"
                        href={`${process.env.REACT_APP_PLATFORM_URL}/expert-details?id=${card.id}`}
                        className="product-image-1"
                      >
                        <img
                          src={card.image}
                          className="card-img"
                          alt={card.nickname}
                          data-id={card.id}
                        />
                      </a>

                      <div className="ms-3 mt-2 mt-sm-0">
                        <div className="d-flex align-items-start">
                          <a
                            data-interaction="expert_name"
                            href={`${process.env.REACT_APP_PLATFORM_URL}/expert-details?id=${card.id}`}
                          >
                            <h5 className="product-name fs-16 fw-semibold mb-0">
                              {card.nickname}
                            </h5>
                          </a>
                        </div>
                        <div className="mt-2 mb-2">
                          <div className="d-flex align-items-start flex-wrap gap-6p ">
                            {card.expertises &&
                            Array.isArray(card.expertises) ? (
                              card.expertises.map((expertises, index) => {
                                const expertiseLabel =
                                  languageData.card.tools[
                                    expertises.toLowerCase()
                                  ];
                                return (
                                  <p
                                    key={index}
                                    className="badge bg-info-transparent fs-11 rounded-1 mb-0"
                                  >
                                    {expertiseLabel}
                                  </p>
                                );
                              })
                            ) : (
                              <p className="badge bg-info-transparent fs-11 rounded-1 mb-0">
                                {card.expertises}{" "}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-start flex-wrap expert_readings">
                          <div className="d-flex px-2 py-2 pt-0 border-end">
                            <div className="text-start d-flex flex-column">
                              <p className="fw-semibold mb-0">
                                {languageData.card.favorite}
                              </p>
                              <span className="btn btn-sm btn-danger-light btn-favorite">
                                <i
                                  className="ri-heart-fill"
                                  /* {
                                    card.favorite
                                      ? "ri-heart-fill"
                                      : "ri-heart-line"
                                  } */
                                ></i>
                              </span>
                            </div>
                          </div>
                          <div className="d-flex px-2 py-2 pt-0 border-end">
                            <div className="text-start">
                              <p className="fw-semibold mb-0">
                                {languageData.card.readings}
                              </p>
                              <span className="text-muted fs-12">
                                {card.readings}
                              </span>
                            </div>
                          </div>
                          <div className="d-flex px-2 py-2 pt-0">
                            <div className="text-start">
                              <p className="fw-semibold mb-0">
                                {languageData.card.ratings}
                              </p>
                              <span className=" fs-12 gold">
                                ★ {card.rating}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-wrap expert_readings_resp hidden">
                      <div className="d-flex px-2 py-2 border-end">
                        <div className="text-start d-flex flex-column">
                          <p className="fw-semibold mb-0">
                            {languageData.card.favorite}
                          </p>
                          <span className="btn btn-sm btn-danger-light btn-favorite">
                            <i
                              className="ri-heart-fill"
                              /* {
                                    card.favorite
                                      ? "ri-heart-fill"
                                      : "ri-heart-line"
                                  } */
                            ></i>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex px-2 py-2 border-end">
                        <div className="text-start">
                          <p className="fw-semibold mb-0">
                            {languageData.card.readings}
                          </p>
                          <span className="text-muted fs-12">
                            {card.readings}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex px-2 py-2">
                        <div className="text-start">
                          <p className="fw-semibold mb-0">
                            {languageData.card.ratings}
                          </p>
                          <span className=" fs-12 gold">★ {card.rating}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card-footer d-sm-flex d-block align-items-center justify-content-end gap-2 px-3"
                    ref={(el) => {
                      if (el)
                        el.style.setProperty("display", "flex", "important");
                    }}
                  >
                    <span
                      className={`badge fs-12 rounded-1 ${
                        card?.status?.toLowerCase() &&
                        languageData.card.status[card.status.toLowerCase()]
                          ? getStatusStyle(
                              languageData.card.status[
                                card.status.toLowerCase()
                              ],
                            )
                          : ""
                      }`}
                    >
                      {getDisplayStatus(card)}
                    </span>

                    <div className="flex d-sm-flex d-block align-items-center justify-content-end gap-2">
                      <button
                        data-interaction="expert_card_call"
                        data-expert={card.id}
                        type="button"
                        className={`btn btn-icon btn-wave waves-effect waves-light ${
                         ["Unavailable"].includes(getInboundStatus(card))
    ? "btn-primary"
    :  ["InUse", "Ringing"].includes(getInboundStatus(card))
                            ? "bg-orange"
                            : card.services.some(
                                  (s) =>
                                    hasService("call") && s.call_type === "prn",
                                )
                              ? "btn-secondary"
                              : "btn-primary"
                        }`}
                       disabled={
  ["Unavailable"].includes(getInboundStatus(card)) ||
  !card.services.some(
    (s) => hasService("call") && s.call_type === "prn",
  )
}
                        onClick={() => {
                          if (
                            ["InUse", "Ringing"].includes(
                              getInboundStatus(card),
                            )
                          )
                            return;
                          handleOpenModal(card);
                        }}
                        data-tooltip-id="call_tooltip"
                        data-tooltip-content={
                          languageData.card.communication.call
                        }
                        data-tooltip-place="bottom"
                      >
                        <i className="ri-phone-fill"></i>
                      </button>
                      <Tooltip id="call_tooltip" />

                      <button
                        data-interaction="expert_card_credit"
                        type="button"
                        data-expert={card.id}
                        className={`btn btn-icon btn-wave waves-effect waves-light ${
                        ["Unavailable"].includes(getInboundStatus(card))
    ? "btn-primary"
    :   ["InUse", "Ringing"].includes(getInboundStatus(card))
                            ? "bg-orange"
                            : card.services.some(
                                  (s) =>
                                    hasService("credit") &&
                                    s.call_type === "credit",
                                )
                              ? "btn-secondary"
                              : "btn-primary"
                        }`}
                      disabled={
  ["Unavailable"].includes(getInboundStatus(card)) ||
  !card.services.some(
    (s) => hasService("credit") && s.call_type === "credit",
  )
}
                        onClick={() => {
                          if (
                            ["InUse", "Ringing"].includes(
                              getInboundStatus(card),
                            )
                          )
                            return;
                          handleOpenModalCredit(card);
                        }}
                        data-tooltip-id="credit_tooltip"
                        data-tooltip-content={
                          languageData.card.communication.credit
                        }
                        data-tooltip-place="bottom"
                      >
                        <i className="ri-bank-card-2-line"></i>
                      </button>
                      <Tooltip id="credit_tooltip" />
                      <button
                        data-interaction="expert_card_chat"
                        type="button"
                        data-expert={card.id}
                        className={`btn btn-icon btn-wave waves-effect waves-light ${
                          card.services.some(
                            (s) =>
                              hasService("chat") && s.communication === "chat",
                          )
                            ? "btn-secondary"
                            : "btn-primary"
                        }`}
                        disabled={
                          !card.services.some(
                            (s) =>
                              hasService("chat") && s.communication === "chat",
                          )
                        }
                        onClick={() => handleOpenModalChat(card)}
                        data-tooltip-id="chat_tooltip"
                        data-tooltip-content={
                          languageData.card.communication.chat
                        }
                        data-tooltip-place="bottom"
                      >
                        <i className="ri-message-2-line"></i>
                      </button>
                      <Tooltip id="chat_tooltip" />

                      <button
                        type="button"
                        data-interaction="expert_card_email"
                        data-expert={card.id}
                        className={`btn btn-icon btn-wave waves-effect waves-light ${
                          card.services.some(
                            (s) =>
                              hasService("email") &&
                              s.communication === "email",
                          )
                            ? "btn-secondary"
                            : "btn-primary"
                        }`}
                        disabled={
                          !card.services.some(
                            (s) =>
                              hasService("email") &&
                              s.communication === "email",
                          )
                        }
                        data-tooltip-id="email_tooltip"
                        data-tooltip-content={
                          languageData.card.communication.email
                        }
                        data-tooltip-place="bottom"
                      >
                        <i className="ri-mail-line"></i>
                      </button>
                      <Tooltip id="email_tooltip" />
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {showModal && (
        <Bycall
          showModal={showModal}
          handleModalClose={handleCloseModal}
          data={{ ...selectedExpert, usercredit: userCredits, max: max }}
          expert={selectedExpert}
        />
      )}
      {showModalChat && (
        <Bychat
          showModalChat={showModalChat}
          handleModalCloseChat={handleCloseModalChat}
          data={{ ...selectedExpert, usercredit: userCredits, max: max }}
          expert={selectedExpert}
        />
      )}
      {showModalCredit && (
        <Bycredit
          showModalCredit={showModalCredit}
          handleModalCloseCredit={handleCloseModalCredit}
          data={{ ...selectedExpert, usercredit: totalCredits, max: max }}
          expert={selectedExpert}
          credits={totalCredits}
        />
      )}
      {showBuyCreditModal && (
        <Buycredit
          show={showBuyCreditModal}
          onClose={() => setShowBuyCreditModal(false)}
          data={{ ...selectedExpert, usercredit: totalCredits, max: max }}
          expert={selectedExpert}
          credits={totalCredits}
        />
      )}

      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <LoadingSpinner />
        </div>
      )}
    </>
  );
};

export default FavoriteContent;
